import { render } from "./PersonaGiuridica.vue?vue&type=template&id=e541b16c"
import script from "./PersonaGiuridica.vue?vue&type=script&lang=js"
export * from "./PersonaGiuridica.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__